import Vue from 'vue'

export async function fetchBenefitsGroup({ commit }, full_legal_number) {
  try {
    const { data } = await Vue.axios({
      url: `/frontend/benefit_groups/benefits_group?view_as=${full_legal_number}`
    })
    commit('setBenefitsGroup', data)
  } catch (error) {
    commit('BenefitsGroupError', error.message)
  } finally {
    // console.log('La peticion de grupo de beneficios ha finalizado')
  }
}

export async function fetchBenefitGroup({ commit }, id) {
  try {
    const { data } = await Vue.axios({
      url: `/frontend/benefits/benefit?id=${id}`
    });
    commit("setBenefitGroup", data);
  } catch (e) {
    commit("benefitGroupError", e.message);
  } finally {
     // console.log("La petición para obtener el grupo de beneficio ha finalizado");
  }
}